import React from 'react';
import 'react-day-picker/lib/style.css';
import DayPicker from 'react-day-picker/DayPicker';


const YearMonthForm = ({ date, localeUtils, onChange, fromMonth, toMonth}) => {
    const months = localeUtils.getMonths();
  
    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
      years.push(i);
    }
  
    const handleChange = function handleChange(e) {
      const { year, month } = e.target.form;
      const newMonth = new Date(year.value, month.value);
      onChange({ month: newMonth });
    };
  
    return (
      <form className="DayPicker-Caption">
        <select name="month" onChange={handleChange} value={date.getMonth()}>
          {months.map((month, i) => (
            <option key={month} value={i}>
              {month}
            </option>
          ))}
        </select>
        <select name="year" onChange={handleChange} value={date.getFullYear()}>
          {years.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </form>
    );
  }

const DayPickerOverlay = ({
    classNames,
    state,
    onDayChange,
    localeUtils,
    date,
    children,
    ...props
  })=>
    {

        return (
          <div className={classNames.overlayWrapper}>
            <div className={classNames.overlay}>
              <div className="YearNavigation">
                <DayPicker
                  month={props.month}
                  fromMonth={props.fromMonth}
                  toMonth={props.toMonth}
                  onDayClick={onDayChange}
                  selectedDays={new Date(date)}
                  captionElement={({ date, localeUtils }) => (
                    <YearMonthForm
                      date={date}
                      localeUtils={localeUtils}
                      onChange={props.handleYearMonthChange}
                      fromMonth={props.fromMonth}
                      toMonth={props.toMonth}
                    />
                  )}
                  modifiers={ {  disabled: {after: new Date() }}}
                />
              </div>
            </div>
          </div>
        );
}

export default DayPickerOverlay;